














import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import DocumentSettingsForm from "@/components/documents/DocumentSettingsForm.vue";
import { Action, Getter } from "vuex-class";
import GlobalFilterSensitiveMixin from "@/mixins/GlobalFilterSensitiveMixin";
import { DocumentSettingsType } from "@/store/modules/documents";
import { cloneDeep } from "lodash";

@Component({
  components: { DocumentSettingsForm },
  mixins: [GlobalFilterSensitiveMixin],
})
export default class Financial extends Vue {
  @Getter("documents/settings") storedSettings?: DocumentSettingsType;
  @Action("documents/refreshModel") refreshSettings?: () => Promise<void>;

  loaded = false;
  model = null as DocumentSettingsType | null;

  @Ref("settings-form") form?: DocumentSettingsForm;

  async refresh() {
    if (!this.refreshSettings) return;
    this.loaded = false;
    try {
      await this.refreshSettings();
      this.model = this.storedSettings ? { ...this.storedSettings } : null;
      this.loaded = true;
    } catch {
      this.$router.replace({ name: "Settings" });
    }
  }

  async created() {
    await this.refresh();
  }

  @Action("documents/saveModel") saveSettings?: (
    x: DocumentSettingsType
  ) => Promise<void>;
  async save() {
    this.loaded = false;

    const cleanedModel = this.cleanPaymentInstructions();

    try {
      if (this.saveSettings && cleanedModel && this.form?.formRef?.validate()) {

        await this.saveSettings(cleanedModel);
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("FinancialSettings.SaveSuccess"),
          timeout: 5000,
        });
        await this.refresh();
      }
    } finally {
      this.loaded = true;
    }
  }

  /**
   * Payment instructions need to be "cleaned" before save because RTE leaves HTML content 
   * inside even if you delete everything in the GUI. We need the string to be empty so 
   * we're able to discriminate between existing/non-existing payment instructions as the
   * entire block is expected to be shown/not shown on documents depending if the payment 
   * instructions are filled in or not. 
   * 
   * The method just searches for text in the RTE DOM since when the content is empty in
   * the RTE it usually leaves something like `<div></div>` or `<div><br></div>` as the "empty
   * content".
   */
  cleanPaymentInstructions()
  {
    const parser = new DOMParser();

    const internalModel = cloneDeep(this.model);

    const { textContent } = parser.parseFromString(internalModel?.financialDocumentPaymentInstructions ?? "", "text/html").documentElement;

    if(!textContent?.trim() && internalModel != null)
    {
      internalModel.financialDocumentPaymentInstructions = "";
    }

    return internalModel;
  }

  @Watch("sensitiveKey")
  async tenantChanged() {
    await this.refresh();
  }
}
